
import Header from "@/components/header/header.vue";
import Voucher from "@/components/voucher/voucher-list-item.vue";
import Sku from "@/components/sku/sku.vue";
import Appad from "@/components/Appad.vue";
import Comment from "@/components/comment/index.vue";
import Recommend from "./recommend.vue";
import Provinces from "./provinces.vue";
import GoogleLogin from '@/views/googleLogin/index.vue'
 

import {
  inject,
  onMounted,
  reactive,
  ref,
  Ref,
  shallowRef,
  onBeforeUnmount,
  watch,
} from "vue";
import { useRouter, useRoute, onBeforeRouteLeave } from "vue-router";
import { Toast } from "vant";
import { getCart, getCommentList } from "@/hooks/index";
export default {
  components: {
    Header,
    Voucher,
    Sku,
    Comment,
    Recommend,
    Provinces,
    Appad,
    GoogleLogin
  },
  beforeRouteEnter(to: any, from: any, next: any) {
    if (!common.getStorage("routerName")) {
      common.setStorage("routerName", from.fullPath);
    }
    next((vm: any) => {});
  },
  setup() {
    const router: any = useRouter();
    const route: any = useRoute();
    const $http: any = inject("$http");
    const $store: any = inject("$store");
    let prestrain: any = $store.getDetails();
    let goods: any = shallowRef({
        //详情基本信息,以下参数回显
        albums: [
          {
            images: prestrain.images ? prestrain.images : prestrain.images,
          },
        ],
        promotion_price: prestrain.promotion_price
          ? prestrain.promotion_price
          : prestrain.goods_price,
        marketprice: prestrain.marketprice
          ? prestrain.marketprice
          : prestrain.goods_marketprice,
        name: prestrain.name ? prestrain.name : prestrain.goods_name,
        rate: prestrain.rate ? prestrain.rate : "",
        flash_info: "",
      }), //详情信息
      currencyUnit: String = $store.getSymbol(), //货币单位
      currency: String = $store.getSite().currency,
      current = ref(0), //swiper右下角数量
      goods_voucher = shallowRef([]), //优惠券
      skuShow = ref(false), //sku显示
      colorValue: any = ref([]), //默认选中的sku
      commentList: any = ref({}), //评价列表
      active = ref<boolean>(false), //评论展示关闭
      _id = ref(route.params.id), //url传递过来的参数
      recommend_list = shallowRef([]), //推荐列表1
      store_recommend = shallowRef([]), //推荐列表2
      store_info: any = shallowRef({}), //店铺资料
      product = shallowRef({}), //详情默认简介
      follow_status = ref(0), //是否收藏
      tabs = reactive(["Product", "Reviews", "Description"]), //tabs切换
      viscidity_tabs = ref(0), //tabs滚动控制样式
      descruption = ref(), //操作dom
      viscidity = ref(), //操作dom
      site_show = ref(false), //地址的显示隐藏
      shopping_number = ref(0), //购物车数量
      countDownList: any = ref(["00", "00", "00"]), //秒杀倒计时
      flashDesc = ref("End up"), //秒杀标题
      voucher_show = ref(false), //优惠券弹窗显示隐藏
      know = ref(true), //是加购还是下单
      commentRef = ref(), //操作dom
      cart = reactive({
        list: [],
      }),
      normal_prices = ref(), //折扣价格
      activeName = ref(0), //优惠券
      small_pic: any = shallowRef([
        {
          images: prestrain.images ? prestrain.images : prestrain.images,
        },
      ]), //默认大图
      swiper_status = ref(false), //是否显示swiper
      variation = ref(true),
      sku_id = ref<number>(0), //sku传递过来的Id
      seckill_btns = ref(true), //秒杀状态下只能下单不能加购
      shopping_cart = ref(true),
      defaultAddress:any = ref({}); // 默认地址信息
    if (common.getStorage("access_token")) {
      // 购物车数量
      getCart().then((ret) => {
        cart.list = ret;
        shopping_number.value = ret && ret.length;
      });
    }
    let shareParams = {
      url:
        process.env.NODE_ENV === "production"
          ? "https://www.kilimall.co.ke/new/goods/" + route.params.id
          : "https://www.kilitest.co.ke/new/goods/" + route.params.id,
      con: goods.value.name + ".  Amazing product,try it out!",
    };
    sessionStorage.setItem("shareParams", JSON.stringify(shareParams));
    let isShowAppad = localStorage.getItem("expiredate")
      ? ref(false)
      : ref(true);
    if(sessionStorage.getItem('source') === 'byteApp') {
      isShowAppad.value = false
    }
    //评价
    interface commentParams {
      pageNo: number,
      pageSize: number,
      objectId: string,
      queryType: number,
      objectType: number
    }
    let comment_params: Ref<commentParams> = ref({
      queryType: 1,
      objectType: 1,
      objectId: '',
      pageSize: 3,
      pageNo: 1
    })
    // 满减包邮
    interface postageType {
      freePostageText: string,
      freePostageThresholdAmount: number,
      isFreePostage:number
    }
    let postageData:Ref<postageType> = ref({
        freePostageText: '',
        freePostageThresholdAmount: 0,
        isFreePostage:0
    })
    const get_comment_init = () => {
      getCommentList($http, comment_params.value).then((req: any) => {
        if (req.code == 200) {
          commentList.value.list = req.data;
          commentList.value.totalNum = req.totalNum
        }
      })
    }

    let app_adjust_arr: any = ref([]);
    //详情信息
    let goods_init_fn = async (val: number) => {
      let ret = await $http.detail(
        { id: val },
        common.getStorage("access_token") ? true : false
      );
      if (ret.code === 200) {
        $store.setDetails({});
        // 导流链接
        // if(window.location.href.includes('.ke')) {
        app_adjust_arr.value = [
          `https://app.adjust.com/h463n7w?deeplink=kiliapp%3A%2F%2Fkilimall%3Ftype%3D4%26data%3D${val}%26shopcode%3D${
            ret.data.store_id
          }%26siteCode%3D${"ke"}`,
          `https://app.adjust.com/tlvi80p?deeplink=kiliapp%3A%2F%2Fkilimall%3Ftype%3D4%26data%3D${val}%26shopcode%3D${
            ret.data.store_id
          }%26siteCode%3D${"ke"}`,
        ];
        // }
        // ga
        var userAgent = navigator.userAgent;
        // 详情页加载时间
        if (
          common.getStorage("start_time") &&
          userAgent.indexOf("kilimall,android") < 0
        ) {
          var start_time = common.getStorage("start_time");
          var end_time = new Date().getTime() - start_time;
          // @ts-ignore
          ga("send", "timing", "new wap goodsDetail", "load", end_time);
        }
        colorValue.value = [];
        goods.value = ret.data;
        comment_params.value.objectId = ret.data.goods_commonid
        get_comment_init()
        swiper_status.value = true;
        let atemporary: Array<object> = [];
        ret.data.albums.forEach((item: any) => {
          if (
            (item.color_id > 0 && item.color_id == ret.data.color_id) ||
            ret.data.color_id == "" ||
            item.color_id == 0
          ) {
            atemporary.push(item);
          }
        });
        small_pic.value = [...atemporary];
        product.value = goods.value.product;
        follow_status.value = goods.value.is_followed;
        for (var i in goods.value.spec_list) {
          for (var n in goods.value.spec_list[i].spec_value) {
            if (
              goods.value.spec_list[i].spec_value[n].spec_value_select == true
            ) {
              colorValue.value.push(
                goods.value.spec_list[i].spec_value[n].spec_value_name
              );
            }
          }
        }
      }
      get_shop_index_fn();
      get_shop_info_fn();
      //优惠券
      $http.get_shop_voucher({ id: goods.value.store_id }).then((res: any) => {
        goods_voucher.value = res.data;
      });
      
      // console.log(9999, JSON.stringify(comment_datas))
    //   let req = await $http.commentList({
    //     goodsId: _id.value,
    //     page: 1,
    //     size: 10,
    //   });
    //   if (req.code === 200) {
    //     commentList.value = req.data;
    //     let arr: any = [];
    //     if (req.data.list && req.data.list.length > 0) {
    //       req.data.list.forEach((i: any) => {
    //         if (i.mediaList && i.mediaList.length > 0) {
    //           arr.unshift(i);
    //         } else {
    //           arr.push(i);
    //         }
    //       });
    //       commentList.value.list = arr.slice(0, 3);
    //     }
    //   }
    };

    //店铺资料
    let get_shop_info_fn = async () => {
      let ret = await $http.get_shop_info({ id: goods.value.store_id });
      if (ret.code === 200) {
        store_info.value = ret.data;
      }
    };
    //推荐
    let recommend = async () => {
      let ret = await $http.recommend({
        goods_id: _id.value,
        total: "10",
        type: "2",
      });
      if (ret.code === 200) {
        recommend_list.value =
          typeof ret.data == "object" ? ret.data.products : [];
      }
    };
    //店铺首页
    let get_shop_index_fn = async () => {
      let reg = await $http.get_shop_index({ id: goods.value.store_id });
      if (reg.code === 200) {
        reg.data.storeRecommend.forEach((i: any) => {
          i.name = i.goods_name;
        });
        store_recommend.value = reg.data.storeRecommend;
      }
    };
    goods_init_fn(_id.value);
    recommend();
    // get_shop_index_fn()
    //自定义显示器
    const onChange = (index: number) => {
      current.value = index;
    };
    //有秒杀价就显示秒杀价
    let get_price_fn = () => {
      var flash_price =
        goods.value.flash_info && goods.value.flash_info.price
          ? goods.value.flash_info.price
          : "";
      //  var price = goods.value.flash_info && goods.value.flash_info.time_status == 2 && goods.value.flash_info.storage !=0 ? flash_price : goods.value.promotion_price;
      return flash_price;
    };
    //有秒杀就用折扣
    const get_price_type_fn = () => {
      var flash_price =
        goods.value.flash_info &&
        goods.value.flash_info.time_status == 2 &&
        goods.value.flash_info.storage != 0
          ? goods.value.flash_info.price
          : "";
      var normal_price = flash_price
        ? flash_price
        : goods.value.promotion_price;
      normal_price =
        ((goods.value.marketprice - normal_price) / goods.value.marketprice) *
        100;
      normal_prices.value = normal_price;
      return parseInt(normal_price);
    };
    get_price_type_fn();
    //添加
    const AddToCart = (val: number) => {
      skuShow.value = true;
      know.value = true;
      variation.value = true;
      if (val === 1) {
        variation.value = false;
      }
    };
    //孙组件传递过来选中的id
    let skuSelected = (val: number) => {
      sku_id.value = val;
    };
    //评论展开关闭
    let arrow_fnc = () => {
      active.value = !active.value;
    };
    //店铺跳转
    let jump_link = () => {
      shopping_cart.value = false;
      if (goods.value && goods.value != "") {
        $store.setStoreInterface("store_interface", store_info.value);
        router.push({
          name: "shop",
          params: {
            id: goods.value.store_id,
          },
        });
      }
    };
    //推荐跳转
    let current_jump = (item: string, id: number, type: number) => {
      $store.setDetails(item);
      router.push({
        name: "goods",
        params: {
          id: id,
        },
      });
      //  setTimeout(() => {
      //     location.reload();
      //   });
      window.scrollTo(0, 0);
    };
    //收藏
    let star_func = async () => {
      if (!localStorage.getItem("access_token")) {
        router.push("/login");
      } else {
        let params = {
          fav_id: _id.value,
          fav_type: "goods",
          action: follow_status.value === 0 ? "insert" : "delete",
        };
        let res = await $http.add_or_cancel_favoriteStore(params);
        if (res != null && res.code === 200) {
          follow_status.value = follow_status.value === 0 ? 1 : 0;
        }
      }
    };
    //tabs
    let handleScroll = () => {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let description;
      if (descruption.value) {
        description = descruption.value.offsetTop;
      }
      if (scrollTop > 300) {
        viscidity.value.style.display = "block";
      } else {
        viscidity.value.style.display = "none";
      }
      let commentRefs;
      if (commentRef.value) {
        commentRefs = commentRef.value.offsetTop;
      }
      if (
        scrollTop >= commentRefs - (isShowAppad.value ? 175 : 105) &&
        scrollTop <= description - (isShowAppad.value ? 180 : 110)
      ) {
        viscidity_tabs.value = 1;
      } else if (scrollTop >= description - (isShowAppad.value ? 170 : 100)) {
        viscidity_tabs.value = 2;
      } else {
        viscidity_tabs.value = 0;
      }
    };
    // 获取商品邮费信息
    const getPostage = async () => {
      let params = defaultAddress.value.city_id ? {
                goods_id: _id.value,
                areaId: defaultAddress.value.city_id
                } : {goods_id:_id.value}
      let reg = await $http.getPostage(params);
      if (reg.code === 200) {
        postageData.value = reg.data
        // 对文案进行处理,序号加粗
        postageData.value.freePostageText =  postageData.value.freePostageText.replace(/\d[.]\s/g,s=>`<strong>${s}</strong>`)
      }
    };
    // 获取地址列表
    const get_address_fn= async ()=> {
            let ret = await $http.post_address({ action: 'select' })
           if(ret.code === 200){
                let address_newList = ret.data
                address_newList.forEach((item:any) => {
                    if(item.is_default == '1') { 
                        defaultAddress.value = item
                    }
                })
                getPostage()
            }
        }
    // 登录了才能获取地址列表 未登录直接获取商品邮费信息
    if(common.getStorage('access_token')){
      get_address_fn()
    }else{
      getPostage()
    }
    window.common.jumpToApp(_id.value);
    onMounted(() => {
      window.scrollTo(0, 0);
      window.addEventListener("scroll", handleScroll, true);
      if (product.value) {
        // facebook埋点
        // @ts-ignore
        fbq("track", "ViewContent", {
          content_type: "product",
          currency: currency,
          content_ids: _id.value,
          value: goods.value.promotion_price,
        });
      }
    });
    onBeforeUnmount(() => {
      window.removeEventListener("scroll", handleScroll, true);
    });
    //定位
    let viscidity_func = (index: number) => {
      if (index === 2) {
        window.scrollTo(
          0,
          descruption.value.offsetTop - (isShowAppad.value ? 170 : 100)
        );
      }
      if (index === 0) {
        window.scrollTo(0, 0);
      }
      if (index === 1) {
        if (commentRef && commentRef.value) {
          window.scrollTo(
            0,
            commentRef.value.offsetTop - (isShowAppad.value ? 170 : 100)
          );
        }
      }
      viscidity_tabs.value = index;
    };
    let fn_reviews = () => {
      viscidity_tabs.value = 1;
      let top =  commentRef.value.offsetTop - (isShowAppad.value ? 170 : 100)
      let $scroll_obj: Element | null = document.querySelector('.page-goods-index')
      if($scroll_obj) $scroll_obj.scrollTo(0, top)
    };
    //添加购物车 //立即购买，转下单页
    let addCart = async (val: number) => {
      if (know.value == true) {
        let ret = await $http.cart_create({
          quantity: val,
          goods_id: goods.value.id,
        });
        if (ret.code === 200) {
          // facebook埋点
          // @ts-ignore
          fbq("track", "AddToCart", {
            content_type: "product",
            currency: currency,
            content_ids: goods.value.id,
            value: goods.value.promotion_price,
          });
          Toast("success");
          let existed = false;
          cart.list.forEach((j: any) => {
            if (j.goods_id != goods.value.id) return;
            existed = true;
          });
          if (!existed) {
            let newCart: any = cart.list.concat(ret.data);
            $store.setCart(newCart);
          }
          shopping_number.value = $store.getCart().length;
        } else {
          Toast(ret.message);
        }
      } else {
        let checkout_goods_datas = {
          cart_id: _id.value + "|" + val,
          ifcart: 0,
        };
        router.push({
          name: "Checkout",
          params: {
            checkout_goods_datas: JSON.stringify(checkout_goods_datas),
          },
        });
      }
    };
    //从Select Variation下单
    let variation_fuc = () => {
      know.value = false;
    };
    //立即购买，转下单页
    let buy_now_fn = () => {
      skuShow.value = true;
      know.value = false;
    };
    //选中地址
    let region_fnc = async (obj: any) => {
      site_show.value = false;
    };
    let shipping_address = () => {
      site_show.value = true;
    };
    let timeFormat = (param: any) => {
      return param < 10 ? "0" + param : param;
    };
    //秒杀
    let countDown = () => {
      var interval = setInterval(() => {
        if (goods.value.flash_info && goods.value.flash_info.time_status < 3) {
          // 获取当前时间
          let newTime = goods.value.flash_info.now_timestamp;
          let endTime = 0;
          if (goods.value.flash_info.time_status == 1) {
            flashDesc.value = "Start In"; // 获取结束时间
            endTime = goods.value.flash_info.start_timestamp;
            if (goods.value.flash_info && goods.value.flash_info.time_status) {
              seckill_btns.value = true;
            }
          } else {
            flashDesc.value = "End In"; // 获取结束时间
            endTime = goods.value.flash_info.end_timestamp;
            if (goods.value.flash_info && goods.value.flash_info.time_status) {
              seckill_btns.value = false;
            }
          }
          let obj = null;
          // 如果活动未结束，对时间进行处理
          if (endTime - newTime > 0) {
            let time: any = endTime - newTime; // 获取天、时、分、秒
            //  let day = parseInt(time / (60 * 60 * 24));
            let hou: any = ((time % (60 * 60 * 24)) / 3600) % 24;
            let min: any = ((time % (60 * 60 * 24)) % 3600) / 60;
            let sec: any = ((time % (60 * 60 * 24)) % 3600) % 60;
            obj = {
              hou: timeFormat(parseInt(hou)),
              min: timeFormat(parseInt(min)),
              sec: timeFormat(parseInt(sec)),
            };
            goods.value.flash_info.now_timestamp =
              goods.value.flash_info.now_timestamp + 1;
          } else {
            // 活动已结束，全部设置为'00'
            obj = {
              // 　day: '00',
              hou: "00",
              min: "00",
              sec: "00",
            };
            clearInterval(interval);
            window.location.reload();
          }
          countDownList.value = [obj.hou, obj.min, obj.sec];
        }
      }, 1000);
    };
    countDown();
    //优惠券
    let get_voucher_now_fn = (val: number) => {
      activeName.value = val;
      voucher_show.value = true;
    };
    //领取优惠券
    let get_voucher_now_fnction = async (item: any) => {
      if (!localStorage.getItem("access_token")) {
        router.push("/login");
      } else {
        let ret = await $http.receiveVoucher({
          store_id: goods.value.store_id,
          id: item.id,
        });
        if (ret.code === 200) {
          Toast("success");
        } else {
          Toast(ret.message);
        }
      }
    };
    //跳转到聊天
    let linkChat = () => {
      if (!localStorage.getItem("access_token")) {
        Toast("Please Log In");
        setTimeout(() => {
          router.push("/login");
        }, 2000);
      } else {
        location.href = `${window.common.old_url()}/message_list_item?token=${$store.getToken()}&mid=${
          store_info.value.member_id
        }&uid=${common.getStorage("user_info").id}&store_name=${
          store_info.value.name
        }&type=shop&storeImgs=${store_info.value.store_avatar}&goods_id=${
          goods.value.id
        }`;
      }
    };
    let skipPath = () => {
      let routerName: any = common.getStorage("routerName")
      if ( routerName &&  routerName != "/" ) {
        common.delStorage("routerName");
        router.push(routerName);
      } else {
        common.delStorage("routerName");
        router.go(-1);
      }
    };
    //礼物跳转
    let present_fnc = (item: any) => {
      let obj = {
        images: item.images,
        name: item.gift_goodsname,
      };
      $store.setDetails(obj);
      router.push({
        name: "goods",
        params: {
          id: item.gift_goodsid,
        },
      });
      setTimeout(() => {
        location.reload();
      });
      window.scrollTo(0, 0);
    };
    //监听
    watch(
      () => route.path,
      () => {
        if (route.params.id && shopping_cart.value == true) {
          goods_init_fn(route.params.id);
          shareParams = {
            url:
              process.env.NODE_ENV === "production"
                ? "https://www.kilimall.co.ke/new/goods/" + route.params.id
                : "https://www.kilitest.co.ke/new/goods/" + route.params.id,
            con: goods.value.name + ".  Amazing product,try it out!",
          };
          sessionStorage.setItem("shareParams", JSON.stringify(shareParams));
        }
      }
    );
    const closeFn = (data: any) => {
      isShowAppad.value = data;
    };
    return {
      goods,
      onChange,
      current,
      currencyUnit,
      get_price_type_fn,
      goods_voucher,
      skuShow,
      AddToCart,
      skuSelected,
      colorValue,
      commentList,
      arrow_fnc,
      active,
      recommend_list,
      store_recommend,
      store_info,
      jump_link,
      product,
      current_jump,
      star_func,
      follow_status,
      tabs,
      viscidity_tabs,
      viscidity_func,
      descruption,
      viscidity,
      site_show,
      addCart,
      shopping_number,
      region_fnc,
      shipping_address,
      flashDesc,
      countDownList,
      voucher_show,
      get_voucher_now_fn,
      get_voucher_now_fnction,
      buy_now_fn,
      commentRef,
      router,
      activeName,
      small_pic,
      linkChat,
      swiper_status,
      present_fnc,
      variation,
      variation_fuc,
      get_price_fn,
      skipPath,
      seckill_btns,
      fn_reviews,
      isShowAppad,
      closeFn,
      app_adjust_arr,
      postageData
    };
  },
};
